module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/picture_2-ca548eeb4417374e9a918c3f1e4604b3.webp";